// removed by extract-text-webpack-plugin
module.exports = {"content":"orders__content-CiN8o blocks__content--MOaB","order":"orders__order-KpHWl","ordersList":"orders__ordersList-3V-pz"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/orders.css
// module id = 776
// module chunks = 0